var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{mask:url(#mask);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0.54,
    y: 0.83,
    width: 82.43,
    height: 20.17,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "0.54 21 82.97 21 82.97 0.83 0.54 0.83 0.54 21"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kilroy Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    d: "M19.36,6.84,16.17,20.77h5.3L24.67,6.84ZM26,1.06h-5.3l-1,4.35H25Zm57,0L75.88,14l-1.56,6.78H69L70.52,14l-1.16-13h5.27V7.73l3-6.67ZM62.55,6.51l-2,8.81a1.39,1.39,0,0,1-1.3,1.16c-.43,0-1-.29-.81-1.16l2-8.81a1.35,1.35,0,0,1,1.3-1.16c.46,0,1,.29.81,1.16ZM62.23.83c-3.39,0-6.2,1.77-7,5.27l-2,8.46C52.38,18.25,54.52,21,58.69,21c3,0,6.17-1.51,7-5.27l2-8.46C68.51,3.79,66.63.83,62.23.83ZM45.59,9.7h-.67l1-4.29h.67c.93,0,1.28.67,1.28,1.53A2.52,2.52,0,0,1,45.59,9.7ZM53.3,5.85c0-3.36-2.17-4.78-5.91-4.78H41.56L37,20.77h5.33L44,13.64h.67l.84,7.13H51l-1.42-8.4A7.49,7.49,0,0,0,53.3,5.85ZM36.38,16.25l-1,4.52H23.85l4.52-19.7h5.39L30.19,16.25Zm-23.9-6.11,2.14,10.63H9.18L7.67,13.06H7.61L5.84,20.77H.54L5.06,1.06h5.3L8.74,8.16h.09l4.49-7.1h5.33Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e60ce70a.svg";
export { ForwardRef as ReactComponent };